"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ExceptionPage = (0, vue_1.resolveComponent)("ExceptionPage");
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_ExceptionPage, { type: '404' }));
}
exports.render = render;
